module.exports = __webpack_public_path__ + "img/0.d95da88d.png";